import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const NewsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		newsheadlines: yup.string().required().label($t('newsheadlines')),
		active: yup.number().nullable().label($t('active')),
		dateadded: yup.string().nullable().label($t('dateadded')),
		addedbyfk: yup.string().nullable().label($t('addedbyfk')),
		datemodified: yup.string().nullable().label($t('datemodified')),
		lastuserfk: yup.string().nullable().label($t('lastuserfk'))
	});
	
	//form default values
	const formDefaultValues = {
		newsheadlines: '', 
		active: '', 
		dateadded: new Date(), 
		addedbyfk: '', 
		datemodified: new Date(), 
		lastuserfk: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/news`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="NewsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewNews')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('newsheadlines')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="newsheadlines"  onChange={formik.handleChange}  value={formik.values.newsheadlines}   label={$t('newsheadlines')} type="text" placeholder={$t('enterNewsheadlines')}        className={inputClassName(formik?.errors?.newsheadlines)} />
                                                <ErrorMessage name="newsheadlines" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('active')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="active"  onChange={formik.handleChange}  value={formik.values.active}   label={$t('active')} type="number" placeholder={$t('enterActive')}  min={0}  step="any"    className={inputClassName(formik?.errors?.active)} />
                                                <ErrorMessage name="active" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateadded')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dateadded" value={formik.values.dateadded} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.dateadded)}        />
                                                <ErrorMessage name="dateadded" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addedbyfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addedbyfk"  onChange={formik.handleChange}  value={formik.values.addedbyfk}   label={$t('addedbyfk')} type="text" placeholder={$t('enterAddedbyfk')}        className={inputClassName(formik?.errors?.addedbyfk)} />
                                                <ErrorMessage name="addedbyfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('datemodified')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="datemodified" value={formik.values.datemodified} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.datemodified)}        />
                                                <ErrorMessage name="datemodified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastuserfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastuserfk"  onChange={formik.handleChange}  value={formik.values.lastuserfk}   label={$t('lastuserfk')} type="text" placeholder={$t('enterLastuserfk')}        className={inputClassName(formik?.errors?.lastuserfk)} />
                                                <ErrorMessage name="lastuserfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
NewsAddPage.defaultProps = {
	primaryKey: 'newsid',
	pageName: 'news',
	apiPath: 'news/add',
	routeName: 'newsadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default NewsAddPage;
